export const PATH_NAV_MAP: Record<string, string> = {
  '/': 'nav.dashboard',
  '/vehicles': 'nav.vehicles',
  '/leads': 'nav.leads.all',
  '/leads/report': 'nav.leads.report',
  '/leads/conversations': 'nav.leads.conversations',
  '/leads/settings/distribution': 'nav.leads.distribution',
  '/leads/settings': 'nav.leads.settings',
  '/leads/settings/kanban': 'nav.leadsSettings.kanban',
  '/leads/settings/webhooks': 'nav.leadsSettings.webhooks',
  '/proposals': 'nav.proposals',
  '/marketplace': 'nav.marketplace',
  '/marketplace/integrations': 'nav.marketplace.integrations',
  '/marketplace/publications': 'nav.marketplace.publications',
  '/marketplace/history': 'nav.marketplace.history',
  '/financial': 'nav.financial',
  '/financial/dashboard': 'nav.financial.dashboard',
  '/financial/charges': 'nav.financial.charges',
  '/financial/benefits': 'nav.financial.benefits',
  '/financial/invoices': 'nav.financial.invoices',
  '/financial/commissions': 'nav.financial.commissions',
  '/financial/commission-rules': 'nav.financial.commissionRules',
  '/financial/closures': 'nav.financial.closures',
  '/financial/fiscal-documents': 'nav.financial.fiscalDocuments',
  '/financial/sales': 'nav.sales.closed',
  '/sales': 'nav.sales',
  '/post-sales': 'nav.postSales',
  '/post-sales/dashboard': 'nav.postSales.dashboard',
  '/post-sales/pipeline': 'nav.postSales.pipeline',
  '/products': 'nav.products',
  '/maintenance': 'nav.maintenance',
  '/users': 'nav.users',
  '/settings': 'nav.settings.general',
  '/settings/theme': 'nav.settings.theme',
  '/settings/dealership': 'nav.settings.dealership',
  '/settings/billing': 'nav.settings.billing',
  '/settings/payment-forms': 'nav.settings.paymentForms',
  '/settings/operation': 'nav.settings.operation',
  '/settings/leads': 'nav.settings.leads',
  '/settings/vehicle-evaluation': 'nav.settings.vehicleEvaluation',
  '/settings/operation/pipeline': 'nav.settings.operationPipeline',
  '/settings/operation/preparation': 'nav.settings.operationPreparation',
  '/settings/leads/sources': 'nav.settings.leadsSources',
  '/settings/leads/media': 'nav.settings.leadsMedia',
  '/settings/role-access': 'nav.roleAccess',
  '/users/edit/me': 'nav.profile',
  '/profile': 'nav.profile',
  '/whatsapp/templates': 'nav.leads.conversations',
};

export const PATH_EXEMPT_FROM_ACCESS_CHECK: string[] = [];

const PATH_PREFIX_NAV: Array<{ prefix: string; navKey: string }> = [
  { prefix: '/vehicles', navKey: 'nav.vehicles' },
  { prefix: '/customers', navKey: 'nav.leads.all' },
  { prefix: '/whatsapp', navKey: 'nav.leads.conversations' },
  { prefix: '/leads', navKey: 'nav.leads' },
  { prefix: '/proposals', navKey: 'nav.proposals' },
  { prefix: '/marketplace', navKey: 'nav.marketplace' },
  { prefix: '/financial', navKey: 'nav.financial' },
  { prefix: '/post-sales', navKey: 'nav.postSales' },
  { prefix: '/products', navKey: 'nav.products' },
  { prefix: '/maintenance', navKey: 'nav.maintenance' },
  { prefix: '/users', navKey: 'nav.users' },
  { prefix: '/settings', navKey: 'nav.settings' },
];

export const OPERATION_TAB_NAV_KEYS: Record<string, string> = {
  'post-sale': 'nav.postSales.pipeline',
  preparation: 'nav.operation.preparation',
  deliveries: 'nav.operation.deliveries',
  receipt: 'nav.operation.receipt',
};

export function isPathExemptFromAccessCheck(pathname: string): boolean {
  const path = pathname.split('?')[0];
  return PATH_EXEMPT_FROM_ACCESS_CHECK.includes(path);
}

function normalizeSearch(search: string): string {
  if (!search) {
    return '';
  }
  return search.startsWith('?') ? search : `?${search}`;
}

function resolveOperationRouteNavKey(path: string, search: string): string | undefined | null {
  if (path === '/operation') {
    const params = new URLSearchParams(normalizeSearch(search).slice(1));
    const tab = params.get('tab') ?? 'post-sale';
    return OPERATION_TAB_NAV_KEYS[tab] ?? undefined;
  }
  if (path.startsWith('/operation/preparation/')) {
    return 'nav.operation.preparation';
  }
  return null;
}

export function resolveNavKeyForLocation(pathname: string, search = ''): string | undefined {
  const path = pathname.split('?')[0];
  const query = search || (pathname.includes('?') ? pathname.slice(pathname.indexOf('?')) : '');

  const operationNavKey = resolveOperationRouteNavKey(path, query);
  if (operationNavKey !== null) {
    return operationNavKey;
  }

  if (PATH_NAV_MAP[path]) {
    return PATH_NAV_MAP[path];
  }

  const sorted = Object.keys(PATH_NAV_MAP)
    .filter(p => p !== '/' && path.startsWith(p))
    .sort((a, b) => b.length - a.length);

  if (sorted.length > 0) {
    return PATH_NAV_MAP[sorted[0]];
  }

  for (const { prefix, navKey } of PATH_PREFIX_NAV) {
    if (path === prefix || path.startsWith(`${prefix}/`)) {
      return navKey;
    }
  }

  return undefined;
}

export function resolveNavKeyForPath(pathname: string, search = ''): string | undefined {
  return resolveNavKeyForLocation(pathname, search);
}

export function getNavKeyForHref(href: string): string | undefined {
  const [base, query = ''] = href.split('?');
  const search = query ? `?${query}` : '';
  return resolveNavKeyForLocation(base, search);
}

export const DEALERSHIP_ROLES = [
  'owner',
  'manager',
  'salesperson',
  'financial',
  'mechanic',
  'viewer',
] as const;
